import React from 'react';

const Safety: React.FC = () => {
  return (
    <div className="max-w-4xl mx-auto space-y-8">
      <section className="card-natural">
        <h1 className="text-4xl font-bold text-clay-500 mb-6">Safety & Emergency Procedures</h1>
        <p className="text-earth-400">
          Your child's safety is my top priority. I have comprehensive safety procedures and emergency plans in place.
        </p>
      </section>

      <section className="card-natural">
        <h2 className="text-3xl font-bold text-clay-500 mb-6">Fire Safety</h2>
        <div className="space-y-4">
          <div className="bg-sage-100 p-6 rounded-lg">
            <h3 className="text-2xl font-semibold text-sage-500 mb-4">Fire Drills</h3>
            <ul className="list-disc list-inside text-earth-400 space-y-2">
              <li>I conduct fire drills at least once a month</li>
              <li>I practice alternate exit routes with the children</li>
              <li>I will notify parents as soon as possible in case of an actual emergency</li>
            </ul>
          </div>

          <div className="mt-6">
            <h3 className="text-2xl font-semibold text-clay-400 mb-4">Evacuation Routes</h3>
            <div className="space-y-4 text-earth-400">
              <div>
                <h4 className="font-semibold">Route One:</h4>
                <ul className="list-disc list-inside ml-4">
                  <li>Exit the front door</li>
                  <li>Turn right</li>
                  <li>Walk across the driveway to the silver flag pole</li>
                </ul>
              </div>
              <div>
                <h4 className="font-semibold">Route Two:</h4>
                <ul className="list-disc list-inside ml-4">
                  <li>Exit out the side sunroom door</li>
                  <li>Turn left</li>
                  <li>Walk across the driveway to the silver flagpole</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="card-natural">
        <h2 className="text-3xl font-bold text-clay-500 mb-6">Shelter in Place</h2>
        <div className="space-y-4 text-earth-400">
          <div>
            <h3 className="text-2xl font-semibold text-sage-500 mb-4">Drills</h3>
            <ul className="list-disc list-inside">
              <li>I conduct shelter in place drills twice a year</li>
              <li>Each drill lasts approximately half an hour</li>
            </ul>
          </div>
          <div>
            <h3 className="text-2xl font-semibold text-sage-500 mb-4">Emergency Location</h3>
            <p>
              In the event of a severe storm or other events where shelter in place is necessary, 
              I will seek shelter with the children in the downstairs toy room away from windows, with the doors closed.
            </p>
          </div>
        </div>
      </section>

      <section className="card-natural">
        <h2 className="text-3xl font-bold text-clay-500 mb-6">Relocation Sites</h2>
        <div className="space-y-4 text-earth-400">
          <div className="bg-clay-100 p-6 rounded-lg">
            <h3 className="text-2xl font-semibold text-clay-400 mb-4">Primary Location</h3>
            <p>Herb and Rosemary Brodt</p>
            <p>2721 Webb Rd, Lafayette, New York, 13084</p>
          </div>
          <div className="bg-clay-100 p-6 rounded-lg">
            <h3 className="text-2xl font-semibold text-clay-400 mb-4">Secondary Location</h3>
            <p>Nancy and John Mueller</p>
            <p>Webb Road, Lafayette, New York, 13084</p>
          </div>
        </div>
      </section>

      <section className="card-natural">
        <h2 className="text-3xl font-bold text-clay-500 mb-6">Regulatory Information</h2>
        <div className="space-y-4 text-earth-400">
          <p>The NYS Group Family regulations are available for review at my home.</p>
          <p>Regulations are available online at: <a href="https://ocfs.ny.gov/main/childcare/daycare-regs" className="text-clay-400 hover:text-clay-500 underline">ocfs.ny.gov/main/childcare/daycare-regs</a></p>
          <div className="mt-4">
            <h3 className="text-2xl font-semibold text-sage-500 mb-4">Important Contacts</h3>
            <ul className="list-disc list-inside space-y-2">
              <li>Child Care Solutions: 315-446-1224</li>
              <li>OCFS: 315-423-5652</li>
              <li>Address: The Atrium, 100 S. Salina St, Suite 350, Syracuse, NY 13202</li>
              <li>Licensor: Ilenay Fuentes</li>
            </ul>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Safety; 